import React, { useState } from 'react';
import { Button, Box, Typography } from '@mui/material';

const ErrorTest = () => {
  const [shouldThrowError, setShouldThrowError] = useState(false);

  if (shouldThrowError) {
    // This will trigger the error boundary
    throw new Error('Test error for Sentry Error Boundary');
  }

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        padding: 3,
      }}
    >
      <Typography variant="h4" gutterBottom>
        Error Boundary Test Page
      </Typography>
      <Button
        variant="contained"
        color="error"
        onClick={() => setShouldThrowError(true)}
        sx={{ mt: 2 }}
      >
        Trigger Error
      </Button>
    </Box>
  );
};

export default ErrorTest; 